<script setup lang="ts">
import { cn } from '@/lib/utils';

import { CircleUserRound } from 'lucide-vue-next';

import type { HTMLAttributes } from 'vue';

const props = withDefaults(
  defineProps<{
    class?: HTMLAttributes['class'];
    userDetailsClass?: HTMLAttributes['class'];
    email?: string;
    fullName?: string;
    truncate?: boolean;
    isLarge?: boolean;
    isSmall?: boolean;
    isOption?: boolean;
  }>(),
  {
    class: null,
    userDetailsClass: null,
    email: '',
    fullName: '',
    truncate: false,
    isLarge: false,
    isSmall: false,
    isOption: false
  }
);
</script>

<template>
  <div
    :class="cn('flex gap-2.5', props.isLarge && 'gap-4', props.class)"
    data-testid="user-info-block"
    :data-id="`user-info-block-${email}`"
  >
    <div
      :class="
        cn(
          'shrink-0 bg-white border border-gray-200 rounded-lg justify-center items-center text-gray-800 text-sm w-10 h-10 inline-flex pointer-events-none',
          props.isSmall && 'w-7 h-7',
          props.isLarge && 'w-12 h-12'
        )
      "
      data-testid="user-info-avatar"
    >
      <CircleUserRound
        :class="
          cn(
            'w-6 h-6 shrink-0 stroke-gray-500 stroke-1',
            props.isSmall && 'w-5 h-5 stroke-1'
          )
        "
      />
    </div>
    <div :class="userDetailsClass">
      <p
        :class="
          cn(
            'break-words text-sm',
            props.isSmall && 'text-xs font-semibold',
            props.isLarge && 'text-lg font-semibold',
            truncate && 'truncate',
            !isOption && 'max-w-64'
          )
        "
        :title="fullName"
        data-testid="user-info-name"
      >
        {{ fullName }}
      </p>
      <p
        :class="
          cn(
            'text-xs font-normal text-gray-500 break-words',
            truncate && 'truncate',
            props.isLarge && 'text-sm font-medium',
            !isOption && 'max-w-64'
          )
        "
        :title="email"
        data-testid="user-info-email"
      >
        {{ email }}
      </p>
    </div>
    <slot></slot>
  </div>
</template>
